import * as React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import {motion} from 'framer-motion'

function Checkbox({
  isChecked,
  onClick,
  id,
  name,
  value,
  children,
  className = '',
  required,
}) {
  return (
    <div
      id={id}
      className={`Component__Checkbox ${className}`}
      onClick={onClick}
    >
      <section
        className={classNames('Component__Checkbox__input-container', {
          'Component__Checkbox__input-container--checked': isChecked,
        })}
      >
        <input
          value={value}
          required={required}
          type='checkbox'
          name={name}
          checked={Boolean(isChecked)}
          onChange={() => {}}
        />
        <svg viewBox='0 0 46 38'>
          <motion.path
            initial={{
              pathLength: isChecked ? 1 : 0,
            }}
            animate={{
              pathLength: isChecked ? 1 : 0,
            }}
            transition={{
              type: 'spring',
              mass: 0.5,
              stiffness: 500,
              damping: 20,
            }}
            d='M5.213,17.548l11.81,11.792l26.549,-26.542'
          />
        </svg>
      </section>
      <section className='Component__Checkbox__input-label'>
        {children} {required && <span className='error'>*</span>}
      </section>
    </div>
  )
}

Checkbox.propTypes = {
  isChecked: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node,
  required: PropTypes.bool,
  name: PropTypes.string,
  value: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
  id: PropTypes.string,
}

export default Checkbox
